var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods-switch"},[_c('span',[_c('el-switch',{attrs:{"active-text":"明细","inactive-text":"精简"},on:{"change":_vm.change},model:{value:(_vm.isShowGoodsList),callback:function ($$v) {_vm.isShowGoodsList=$$v},expression:"isShowGoodsList"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }